import React, { useState, useEffect } from 'react'
import Modal from "../../utils/Modal";
import DatePickerModule from '../../utils/DatePicker';
import * as moment from 'moment'
import { TypeBestOf } from '../../model/TypeBestOf';
import { useBestOf } from '../../context/BestOf';
import { useMenuBestOf } from '../../context/MenuBestOf';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  button: {
    fontSize: "1em",
    borderRadius: "5px",
    margin: "10px 0px",
    cursor: "pointer",
    width: "200px"
  },
  buttonGroupModal: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    alignItems: "center",
    width: "50%"
  },
  modalButtonNew: {
    marginBottom: 10
  }
}));

const ModalOptions = () => {
  const classes = useStyles();
  const {dispatch, state} = useBestOf();
  const { dispatch: dispatchMenu, state: stateMenu} = useMenuBestOf();
  const [show, setShow] = useState(false);
  const [customize, setCustomize] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(undefined);
  const [disabled, setDisabled] = useState(false);

  const showModal = () => {
    setShow(true);
  };

  const hideModal = () => {
    setShow(false);
  };

  const validateDate = () => {
    let weeks = [];
    let end = moment.utc(endDate).format("YYYY-MM-DD");

    for (let i = 0; i <= 7; i++) {
      let day = moment.utc(startDate).add(i, 'days').format("YYYY-MM-DD");
      if (day !== end) {
        weeks.push(day)
      } else {
        weeks.push(day);
        dispatchMenu({type: "SET_DAYS_BEST_OF", payload: {daysBestOf: weeks}})
        setCustomize(false)
        dispatchMenu({type: "SET_IS_NEW_BEST_OF", payload: {isNewBestOf: true}})
        break;
      }
    }
  }

  const newBlankBestOf = () => {
    dispatchMenu({type: "SET_IS_NEW_BEST_OF", payload: {isNewBestOf: true}});
    setCustomize(false);
  }

  useEffect(() => {
    if (startDate && endDate) {
      var start= moment.utc(startDate);
      var end= moment.utc(endDate);
      var difference= end.diff(start, 'days');
      var workingDays= Math.round((difference/7)*7) + 1;
      if (workingDays <= 7) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
    }
  }, [startDate, endDate])

  useEffect(() => {
    dispatch({type: "RESET_BEST_OF"})
  }, [])

  let resetBestOf = () => {
    dispatch({type: "RESET_BEST_OF"})
    dispatchMenu({type: "SET_DAYS_BEST_OF", payload: {daysBestOf: null}})
    console.log("State: ", state);
  }

  return (
    <>
      <Modal show={show} handleClose={hideModal}>
        <h2>Best Of </h2> {/*par {(stateMenu.typeBestOf === TypeBestOf.DAYS) ? "jours" : "thèmes" } */}
        {customize && 
          <>
            <DatePickerModule startDate={startDate} endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate} />
            <p style={{fontSize: 25}}>Date choisie: {moment.utc(startDate).format("DD/MM/YY")}-{(endDate) ? moment.utc(endDate).format("DD/MM/YY") : "nodate"}</p>
            <Button variant="outlined" className={classes.button} disabled={disabled || !startDate || !endDate} onClick={() => validateDate()}>
              Valider les dates
            </Button>
          </>
        }
        {disabled && <p style={{color: '#FF0000'}}>Erreur la plage de jour ne doit pas dépasser 7 jours !</p>}
        <div className={classes.buttonGroupModal}>
          <Button variant="outlined" className={classes.button} onClick={() => newBlankBestOf()}>
            Nouveau Best of *
          </Button>
          {(stateMenu.typeBestOf === TypeBestOf.DAYS)
          &&
            <Button variant="outlined" className={classes.button} onClick={() => setCustomize(!customize)}>
              {!customize ? "Nouveau Best of personnalisé" : "Fermer le best of personnalisé"}
            </Button>
          }
        </div>
        <p>(* Les Best of classic prennent la date à partir du dernier vendredi, vendredi jour-j inclue)</p>
      </Modal>
      <Button variant="outlined" className={[classes.button, classes.modalButtonNew].join(" ")} id="modal-button-new" type="button" onClick={() => {showModal(); resetBestOf()}}>
        Nouveau Best of
      </Button>
    </>
  );
};

export default ModalOptions;
